import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  // START
  QUERY_START: `${actionPrefix}_QUERY_START`,
  MUTATION_START: `${actionPrefix}_MUTATION_START`,
  MUTATION_PRIVACY_START: `${actionPrefix}_MUTATION_PRIVACY_START`,
  SUBSCRIPTION_START: `${actionPrefix}_SUBSCRIPTION_START`,

  // SUCCESS
  QUERY_SUCCESS: `${actionPrefix}_QUERY_SUCCESS`,
  MUTATION_SUCCESS: `${actionPrefix}_MUTATION_SUCCESS`,
  SUBSCRIPTION_NEW_DATA_SUCCESS: `${actionPrefix}_SUBSCRIPTION_NEW_DATA_SUCCESS`,
  MUTATION_PRIVACY_SUCCESS: `${actionPrefix}_MUTATION_PRIVACY_SUCCESS`,

  // FAILURE
  QUERY_FAILURE_GENERIC: `${actionPrefix}_QUERY_FAILURE_GENERIC`,
  SUBSCRIPTION_FAILURE: `${actionPrefix}_SUBSCRIPTION_FAILURE`,
  QUERY_FAILURE_401: `${actionPrefix}_QUERY_FAILURE_401`,
  MUTATION_FAILURE_GENERIC: `${actionPrefix}_MUTATION_FAILURE_GENERIC`,
  MUTATION_PRIVACY_FAILURE_GENERIC: `${actionPrefix}_MUTATION_PRIVACY_FAILURE_GENERIC`,
  MUTATION_FAILURE_401: `${actionPrefix}_MUTATION_FAILURE_401`,
  MUTATION_PRIVACY_FAILURE_401: `${actionPrefix}_MUTATION_PRIVACY_FAILURE_401`,

  // USER INTERACTION
  OPEN_PREFERENCES_LIST: `${actionPrefix}_OPEN_PREFERENCES_LIST`,
  CLOSE_PREFERENCES_LIST: `${actionPrefix}_CLOSE_PREFERENCES_LIST`,
  SELECT_OPTIONS: `${actionPrefix}_SELECT_OPTIONS`,
  UPDATE_MESSAGES: `${actionPrefix}_UPDATE_MESSAGES`,
});

export const getActions = (actionPrefix) => ({
  // START
  setQueryStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_START,
    });
  },
  setMutationStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_START,
    });
  },
  setMutationPrivacyStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_PRIVACY_START,
    });
  },
  setSubscriptionStart: (unsubscribe) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SUBSCRIPTION_START,
      payload: { unsubscribe },
    });
  },

  // SUCCESS
  setQuerySuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_SUCCESS,
      payload: { data },
    });
  },
  setMutationSuccess: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_SUCCESS,
    });
  },
  setSubscriptionNewDataSuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SUBSCRIPTION_NEW_DATA_SUCCESS,
      payload: { data },
    });
  },
  setMutationPrivacySuccess: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_PRIVACY_SUCCESS,
    });
  },

  // FAILURE
  setQueryFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setSubscriptionFailure: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SUBSCRIPTION_FAILURE,
      payload: { error },
    });
  },
  setQueryFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_401,
      payload: { error },
    });
  },
  setMutationFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setMutationPrivacyFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_PRIVACY_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setMutationFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_FAILURE_401,
      payload: { error },
    });
  },
  setMutationPrivacyFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_PRIVACY_FAILURE_401,
      payload: { error },
    });
  },

  // USER INTERACTION
  openPreferencesList: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).OPEN_PREFERENCES_LIST,
    });
  },
  closePreferencesList: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).CLOSE_PREFERENCES_LIST,
    });
  },
  selectPreferences: (options) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SELECT_OPTIONS,
      payload: { options },
    });
  },
  updateMessages: (messages) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).UPDATE_MESSAGES,
      payload: { messages },
    });
  },
});
